export default "__VITE_ASSET__ek4vpBue__"